import React, { useState, useEffect } from "react";
import { Formik, Field, Form, FieldArray, ErrorMessage } from "formik";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import BranchForm from "../Forms/BranchForm";
import {
  CustomSelect,
  getData,
  MaskedInputField,
  postData,
} from "../Commonfunction/CommonFunction";
import CommonModal from "../common/CommonModal";
import "../../assets/style/EmployeForm.css";
import { AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";
import { CiSquarePlus } from "react-icons/ci";
import { IoArrowBack } from "react-icons/io5";

import StateForms from "../Forms/StateForms";
import dayjs from "dayjs";
import "../../assets/style/AddClientForm.css";
import CountyForm from "../Forms/CountyForm";

export default function AddClientForm({ setFieldValue }) {
  const [expanded, setExpanded] = React.useState(false);
  const [branchModal, setBranchModal] = useState(false);
  const [stateModal, setStateModal] = useState(false);
  const [cityModal, setCityModal] = useState(false);
  const [countyModal, setCountyModal] = useState(false);
  const [employeeModal, setEmployeeModal] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [branchData, setBranchData] = useState();
  const [singleData, setSingleData] = useState();
  const [employeeData, setEmployeeData] = useState();
  const [emailOperatorData, setEmailOperatorData] = useState();
  const [dataEntryOperatorData, setDataEntryOperatorData] = useState();
  const [reviewerData, setReviewerData] = useState();
  const [teamLeadData, setTeamLeadData] = useState();
  const [taxHeadData, setTaxHeadData] = useState();
  const [dropdownList, setDropdownList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [countyList, setCountyList] = useState([]);
  const [newTaxHeadData, setNewTaxHeadData] = useState();
  const [businessTypeData, setBusinessTypeData] = useState();
  const location = useLocation();
  const forTaxHead = location.state?.activeStep;
  const pillButtonStyle = {
    display: "inline-block",
    padding: "2px 10px",
    margin: "2px",
    borderRadius: "50px",
    backgroundColor: "#007BFF", // Primary color
    border: "1px solid",
    color: "#fff",
    // boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // 3D shadow effect
    fontSize: "13px",
    fontWeight: "bold",
    transition: "all 0.3s ease",
    cursor: "pointer",
  };
  useEffect(() => {
    setTimeout(() => {
      if (forTaxHead) {
        const targetElement123 = document.getElementById("target-section");
        if (targetElement123) {
          targetElement123.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, 1500);
    fetchData();
  }, []);

  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    setExpanded(forTaxHead ? forTaxHead : "panel1");
  }, []);
  const branchList = async () => {
    try {
      const result = await getData("/api/all-branches");
      if (result.success) {
        setBranchData(result.data);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const dropdownData = async () => {
    try {
      const result = await getData("/api/get-state-department-designation");

      if (result.success) {
        setDropdownList(result.data); // ✅ use setter, not a hook
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const zipcodeData = async (one, two, setFieldValue) => {
    setFieldValue(`city`, "");
    setFieldValue(`county`, "");
    setFieldValue(`state_id`, "");
    setFieldValue(`tax_info.[0].state`, "");
    setFieldValue(`tax_info.[0].county`, "");
    setFieldValue(`tax_info.[0].city`, "");
    setFieldValue(`tax_info.[0].zip_code`, "");
    setFieldValue(`tax_info.[0].total_ga_tax`, "");
    setFieldValue(`tax_info.[0].state_tax`, "");
    setFieldValue(`tax_info.[0].county_tax`, "");
    setFieldValue(`tax_info.[0].vendor_comp_above_rate`, "");
    setFieldValue(`tax_info.[0].vendor_comp_below_rate`, "");
    setFieldValue(`tax_info.[0].vendor_comp_above`, "");
    setFieldValue(`tax_info.[0].vendor_comp_below`, "");
    setFieldValue(`tax_info.[0].on_road_fuel`, "");
    setFieldValue(`tax_info.[0].off_road_fuel`, "");

    setFieldValue(`tax_info.[0].occup_tax`, "");
    setFieldValue(`tax_info.[0].occup_credit`, "");
    setFieldValue(`tax_info.[0].per_room_tax`, "");

    setFieldValue(`tax_info.[0].food_sales`, "");
    setFieldValue(`tax_info.[0].non_food`, "");
    setFieldValue(`tax_info.[0].cbd_sales`, "");
    setFieldValue(`tax_info.[0].local_tax`, "");

    setFieldValue(`tax_info.true`, true);

    try {
      const result123 = await postData(
        "/api/get-zipcode-by-city-county-desgination-dept",
        {
          // state_id: one,
          zipcode: two,
        }
      );
      if (result123?.success) {
        setFieldValue(`state_id`, result123.data.state_name);
        setFieldValue(`city`, result123.data.city_name);
        setFieldValue(`county`, result123.data.county_name);
        setFieldValue(`tax_info.[0].zip_code`, two);
        setFieldValue(`tax_info.[0].state`, result123.data.state_name);
        setFieldValue(`tax_info.[0].county`, result123.data.county_name);
        setFieldValue(`tax_info.[0].city`, result123.data.city_name);
        setFieldValue(`tax_info.[0].total_ga_tax`, result123.data.rate);
        setFieldValue(`tax_info.[0].state_tax`, result123.data.state_rate);
        setFieldValue(`tax_info.[0].county_tax`, result123.data.county_rate);
        setFieldValue(
          `tax_info.[0].vendor_comp_above_rate`,
          result123.data.vendor_comp_above_rate
        );
        setFieldValue(
          `tax_info.[0].vendor_comp_below_rate`,
          result123.data.vendor_comp_below_rate
        );
        setFieldValue(
          `tax_info.[0].vendor_comp_above`,
          result123.data.vendor_comp_above_per
        );
        setFieldValue(
          `tax_info.[0].vendor_comp_below`,
          result123.data.vendor_comp_below_per
        );
        setFieldValue(`tax_info.[0].on_road_fuel`, result123.data.on_road_fuel);
        setFieldValue(
          `tax_info.[0].off_road_fuel`,
          result123.data.off_road_fuel
        );

        setFieldValue(`tax_info.[0].occup_tax`, result123.data.occup_tax);
        setFieldValue(`tax_info.[0].occup_credit`, result123.data.occup_credit);
        setFieldValue(`tax_info.[0].per_room_tax`, result123.data.per_room_tax);

        setFieldValue(`tax_info.[0].food_sales`, result123.data.food_sales);
        setFieldValue(`tax_info.[0].non_food`, result123.data.non_food);
        setFieldValue(`tax_info.[0].cbd_sales`, result123.data.cbd_sales);
        setFieldValue(`tax_info.[0].local_tax`, result123.data.local_tax);
      }
    } catch (error) {
      // console.log("Error: ", error);
      //   toast.error(result123.message);
    }
  };

  const zipcodeDataVenderConp = async (one, two, setFieldValue, index) => {
    // Clear previous values
    setFieldValue(`tax_info.${index}.state`, "");
    setFieldValue(`tax_info.${index}.county`, "");
    setFieldValue(`tax_info.${index}.city`, "");
    setFieldValue(`tax_info.${index}.total_ga_tax`, "");
    setFieldValue(`tax_info.${index}.state_tax`, "");
    setFieldValue(`tax_info.${index}.county_tax`, "");
    setFieldValue(`tax_info.${index}.vendor_comp_above_rate`, "");
    setFieldValue(`tax_info.${index}.vendor_comp_below_rate`, "");
    setFieldValue(`tax_info.${index}.vendor_comp_above`, "");
    setFieldValue(`tax_info.${index}.vendor_comp_below`, "");
    setFieldValue(`tax_info.${index}.on_road_fuel`, "");
    setFieldValue(`tax_info.${index}.off_road_fuel`, "");
    setFieldValue(`tax_info.${index}.occup_tax`, "");
    setFieldValue(`tax_info.${index}.occup_credit`, "");
    setFieldValue(`tax_info.${index}.per_room_tax`, "");

    setFieldValue(`tax_info.${index}.food_sales`, "");
    setFieldValue(`tax_info.${index}.non_food`, "");
    setFieldValue(`tax_info.${index}.cbd_sales`, "");
    setFieldValue(`tax_info.${index}.local_tax`, "");

    try {
      const result123 = await postData(
        "/api/get-zipcode-by-city-county-desgination-dept",
        {
          // state_id: "",
          zipcode: two,
        }
      );

      if (result123?.success) {
        setFieldValue(`tax_info.${index}.state`, result123.data.state_name);
        setFieldValue(`tax_info.${index}.county`, result123.data.city_name); // Update county
        setFieldValue(`tax_info.${index}.city`, result123.data.county_name); // Update city
        setFieldValue(`tax_info.${index}.total_ga_tax`, result123.data.rate);
        setFieldValue(`tax_info.${index}.state_tax`, result123.data.state_rate);
        setFieldValue(
          `tax_info.${index}.county_tax`,
          result123.data.county_rate
        );
        setFieldValue(
          `tax_info.${index}.vendor_comp_above_rate`,
          result123.data.vendor_comp_above_rate
        );
        setFieldValue(
          `tax_info.${index}.vendor_comp_below_rate`,
          result123.data.vendor_comp_below_rate
        );
        setFieldValue(
          `tax_info.${index}.vendor_comp_above`,
          result123.data.vendor_comp_above_per
        );
        setFieldValue(
          `tax_info.${index}.vendor_comp_below`,
          result123.data.vendor_comp_below_per
        );
        setFieldValue(
          `tax_info.${index}.on_road_fuel`,
          result123.data.on_road_fuel
        );
        setFieldValue(
          `tax_info.${index}.off_road_fuel`,
          result123.data.off_road_fuel
        );

        setFieldValue(`tax_info.${index}.occup_tax`, result123.data.occup_tax);
        setFieldValue(
          `tax_info.${index}.occup_credit`,
          result123.data.occup_credit
        );
        setFieldValue(
          `tax_info.${index}.per_room_tax`,
          result123.data.per_room_tax
        );

        setFieldValue(
          `tax_info.${index}.food_sales`,
          result123.data.food_sales
        );
        setFieldValue(`tax_info.${index}.non_food`, result123.data.non_food);
        setFieldValue(`tax_info.${index}.cbd_sales`, result123.data.cbd_sales);
        setFieldValue(`tax_info.${index}.local_tax`, result123.data.local_tax);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(error?.message || "An error occurred");
    }
  };
  const cityData = async (cityId) => {
    try {
      const request_url = `/api/get-city-by-state/${cityId}`;
      const result = await getData(request_url);
      if (result.success) {
        setCityList(result.data); // ✅ This is the correct usage
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const [countyOptions, setCountyOptions] = useState([]);

  const taxInfoCountyData = async (stateId, index1) => {
    try {
      const request_url = `/api/get-county-by-state/${stateId}`;
      const result = await getData(request_url);
      const selectedStateCounties = result.data;
      setCountyOptions(selectedStateCounties);
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const CountyData = async (cityId) => {
    try {
      const request_url = `/api/all-counties`;
      const result = await getData(request_url);
      if (result.success) {
        setCountyList(result.data); // ✅ Correct usage
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const singleCustomerData = async () => {
    try {
      const result = await getData(`/api/get-customer/${id}`);
      if (result.success) {
        setSingleData(result.data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const employeeList = async () => {
    try {
      const result = await getData(`/api/all-employees`);
      if (result.success) {
        const data = result.data.map((item) => ({
          label: item.employee_name,
          value: item.id,
        }));

        setEmployeeData(data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const emailOperatorList = async () => {
    try {
      const result = await getData(`/api/all-email-operators`);
      if (result.success) {
        const data = result.data.map((item) => ({
          label: item.employee_name,
          value: item.id,
        }));

        setEmailOperatorData(data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const dataEntryOperatorList = async () => {
    try {
      const result = await getData(`/api/all-data-entry-operators`);
      if (result.success) {
        const data = result.data.map((item) => ({
          label: item.employee_name,
          value: item.id,
        }));

        setDataEntryOperatorData(data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const reviewerList = async () => {
    try {
      const result = await getData(`/api/all-reviewers`);
      if (result.success) {
        const data = result.data.map((item) => ({
          label: item.employee_name,
          value: item.id,
        }));

        setReviewerData(data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const teamLeadList = async () => {
    try {
      const result = await getData(`/api/all-team-leads`);
      if (result.success) {
        const data = result.data.map((item) => ({
          label: item.employee_name,
          value: item.id,
        }));

        setTeamLeadData(data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const taxHeadList = async (id) => {
    try {
      const result = await getData(`/api/get-tax-head-by-business-type/${id}`);
      if (result.success) {
        const data = result.data.map((item) => ({
          label: item.tax_head_name,
          value: item.id,
        }));
        setTaxHeadData(data);
      } else {
        //    toast.error("Error: ", error);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const handleSubmit = async (values) => {
    setSubmitLoader(true);
    const tax_head_api = {
      tax_head: values.tax_head,
    };
    try {
      const request_url = forTaxHead
        ? `/api/update-customer-tax-head/${id}`
        : id
        ? `/api/update-customer/${id}`
        : "/api/create-customer";
      const postDataResult = await postData(
        request_url,
        forTaxHead ? tax_head_api : values
      );
      if (postDataResult.success) {
        toast.success(postDataResult.message);
        setSubmitLoader(false);
        navigate("/Client");
      } else {
        // console.log("test==>121", postDataResult);
        toast.error(postDataResult.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const fetchDataTaxHead = async (items) => {
    // console.log("fetchDataTaxHead====>", items)
    try {
      const result = await getData("/api/all-tax-heads-listing");
      if (result.success) {
        const taxHeaddataNew = result.data?.find(
          (business) => business.business_type === items
        );
        setNewTaxHeadData(taxHeaddataNew);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const groupedData = newTaxHeadData?.types?.reduce((acc, item) => {
    if (!acc[item.type]) {
      acc[item.type] = [];
    }
    acc[item.type].push(item.tax_head_name);
    return acc;
  }, {});
  const companyType = [
    {
      label: "Corporation",
      value: "Corporation",
    },
    {
      label: "Estate",
      value: "Estate",
    },
    {
      label: "Fiduciary",
      value: "Fiduciary",
    },
    {
      label: "Individual",
      value: "Individual",
    },
    {
      label: "LLC",
      value: "LLC",
    },
    {
      label: "Partnership",
      value: "Partnership",
    },
    {
      label: "Subchapter S Corp.",
      value: "Subchapter S Corp.",
    },
  ];
  const fetchData = async () => {
    try {
      const result = await getData("/api/all-tax-heads-listing");
      if (result.success) {
        const typeData = result.data?.map((item) => {
          return { label: item.business_type, value: item.business_type };
        });
        setBusinessTypeData(typeData);
      } else {
        // setPermissionsData(result.permission);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const businessType = [
    {
      label: "Retail - Convenience Store - Gas",
      value: "Retail - Convenience Store - Gas",
    },
    {
      label: "Retail - Liquor Store",
      value: "Retail - Liquor Store",
    },
    {
      label: "Retail - Fast Food Restaurant",
      value: "Retail - Fast Food Restaurant",
    },
    {
      label: "Hotel - Motel",
      value: "Hotel - Motel",
    },
  ];
  const validationSchema = Yup.object().shape({
    branch_id: Yup.string().required("Please select branch"),
    company_name: Yup.string().required("Company name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    mobile_no: Yup.string().test(
      "length",
      "Mobile number must be 10 digits long.",
      (value) => {
        if (!value) return false;
        const digits = value.replace(/\D/g, "");
        return digits.length >= 11;
      }
    ),

    s_and_u_number: Yup.string().required("Please enter S&U number"),
    ein_number: Yup.string().required("Please enter EIN number"),
    zip_code: Yup.string().required("Please select Zipcode"),

    bank_details: Yup.array().of(
      Yup.object().shape({
        is_primary: Yup.string().required("Please select primary bank account"),
        account_holder_name: Yup.string().required(
          "Account holder name is required"
        ),
        bank_name: Yup.string().required("Bank name is required"),
        bank_branch: Yup.string().required("Bank branch is required"),
        account_type: Yup.string().required("Bank account type is required"),
        routing_number: Yup.string().required("Routing number is required"),
        bank_account_no: Yup.string().required(
          "Bank account number is required"
        ),
        bank_account_no_cnf: Yup.string()
          .required("Confirm account number is required")
          .oneOf(
            [Yup.ref("bank_account_no"), null],
            "Account numbers must match"
          ),

        username: Yup.string().required("Username is required"),
        password: Yup.string().required("Password is required"),
      })
    ),
    tax_info: Yup.array().of(
      Yup.object().shape({
        state: Yup.string().required("Please select state"),
        county: Yup.string().required("Please select county"),
        total_ga_tax: Yup.number()
          .typeError("Total GA Tax must be a number")
          .required("Total GA Tax is required")
          .min(0, "Total GA Tax must be at least 0")
          .max(100, "Total GA Tax cannot exceed 100"),
        state_tax: Yup.number()
          .typeError("State Tax must be a number")
          .required("State Tax is required")
          .min(0, "State Tax must be at least 0")
          .max(100, "State Tax cannot exceed 100"),
        county_tax: Yup.number()
          .typeError("County Tax must be a number")
          .required("County Tax is required")
          .min(0, "County Tax must be at least 0")
          .max(100, "County Tax cannot exceed 100"),
        on_road_fuel: Yup.string().required("On Road Fuel is required"),
        off_road_fuel: Yup.string().required("Off Road Fuel is required"),
      })
    ),
    email_operator_id: Yup.string().required("Please select email operator"),
    data_entry_operator_id: Yup.string().required(
      "Please select data entry operator"
    ),
    reviewer_id: Yup.string().required("Please select reviewer"),
    team_lead_id: Yup.string().required("Please select team lead"),
  });
  const handleClose = () => {
    setBranchModal(false);
    setStateModal(false),
      setCountyModal(false),
      setCityModal(false),
      setEmployeeModal(false),
      branchList(),
      dropdownData(),
      cityData(),
      CountyData();
  };

  useEffect(() => {
    id && singleCustomerData();
  }, []);

  useEffect(() => {
    employeeList();
    emailOperatorList();
    dataEntryOperatorList();
    reviewerList();
    teamLeadList();
    branchList();
  }, []);
  useEffect(() => {
    dropdownData();
    CountyData();
    // fetchDataTaxHead()
  }, []);

  useEffect(() => {
    singleData?.state && taxInfoCountyData(singleData?.state);
  }, [singleData?.state]);

  useEffect(() => {
    if (forTaxHead || singleData?.business_type) {
      taxHeadList(singleData?.business_type);
    }
  }, [singleData?.business_type]);
  useEffect(() => {
    singleData?.business_type && fetchDataTaxHead(singleData?.business_type);
  }, [singleData?.business_type]);

  const boxStyles = {
    background: "#f8fafc",
    padding: "7px 5px",
    border: "1px solid #ddd",
    borderRadius: "10px",
    margin: "auto",
    textAlign: "center",
    // cursor: "pointer"
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };
  const textSty = {
    color: "#083162",
    fontWeight: "600",
    fontSize: "18px",
  };

  return (
    <div className="bg-white">
      <Formik
        initialValues={{
          // part:-1
          branch_id: id ? singleData?.branch_id : "",
          customer_name: id ? singleData?.customer_name : "",
          business_type: id ? singleData?.business_type : "",
          company_name: id ? singleData?.company_name : "",
          email: id ? singleData?.email : "",
          company_type: id ? singleData?.company_type : "",
          dba_name: id ? singleData?.dba_name : "",
          zip_code: id ? singleData?.zip_code : "",
          street_1: id ? singleData?.street_1 : "",
          street_2: id ? singleData?.street_2 : "",
          city: id ? singleData?.city : "",
          state_id: id ? singleData?.state : "",
          s_and_u_number: id ? singleData?.s_and_u_number : "",
          company_occupation_no: id ? singleData?.company_occupation_no : "",
          hm_fee: id ? singleData?.hm_fee : "",

          industry: id ? singleData?.industry : "",
          ein_number: id ? singleData?.ein_number : "",
          mobile_no: id ? singleData?.mobile_no : "",
          landline_no: id ? singleData?.landline_no : "",
          county: id ? singleData?.county : "",

          client_since: singleData?.client_since
            ? dayjs(singleData?.client_since)
            : null,
          date_est: singleData?.date_est ? dayjs(singleData?.date_est) : null,
          client_owner: id ? singleData?.client_owner : "",
          external_id: id ? singleData?.external_id : "",
          // part:-2
          bank_details: id
            ? singleData?.bank_details
            : [
                {
                  is_primary: false,
                  bank_account_no: "",
                  routing_number: "",
                  bank_micr_code: "",
                  bank_name: "",
                  account_holder_name: "",
                  bank_branch: "",
                  username: "",
                  password: "",
                  bank_account_no_cnf: "",
                  account_type: "",
                },
              ],

          // part:-3
          tax_info: id
            ? singleData?.tax_info
            : [
                {
                  state: "",
                  city: "",
                  county: "",
                  total_ga_tax: "",
                  state_tax: "",
                  county_tax: "",
                  occup_tax: "",
                  occup_credit: "",
                  per_room_tax: "",
                  zip_code: "",
                  vendor_comp_above: 0,
                  vendor_comp_below: 0,
                  on_road_fuel: "",
                  off_road_fuel: "",
                  is_off_on_road: true,
                  is_prepaid: true,
                  food_sales: "",
                  non_food: "",
                  cbd_sales: "",
                  local_tax: "",

                  state_tax_status: true,
                  county_tax_status: true,
                  total_ga_tax_status: true,
                  food_sales_status: true,
                  non_food_status: true,
                  cbd_sales_status: true,
                  local_tax_status: true,
                  vendor_comp_above_status: true,
                  vendor_comp_below_status: true,
                  on_road_fuel_status: true,
                  off_road_fuel_status: true,
                  occup_tax_status: true,
                  occup_credit_status: true,
                  per_room_tax_status: true,
                },
              ],

          // part:-4
          email_operator_id: id ? singleData?.email_operator_id : "",
          data_entry_operator_id: id ? singleData?.data_entry_operator_id : "",
          reviewer_id: id ? singleData?.reviewer_id : "",
          team_lead_id: id ? singleData?.team_lead_id : "",
          tax_head: id ? singleData?.tax_head : [],
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const finalvalue = {
            ...values,
            state: values.state_id,
          };
          // console.log('finalvalue====', finalvalue)

          handleSubmit(finalvalue);
        }}
      >
        {({ errors, touched, setFieldValue, values, value }) => (
          <Form className="modern-form-container">
            <div className="heading-wrapper">
              <button
                type="button"
                className="back-button"
                onClick={() => navigate("/Client")}
                title="Back to Employees"
              >
                <IoArrowBack />
              </button>
              <h2 className="form-heading">
                {id ? "Edit Client" : "Add Client"}
              </h2>
            </div>
            <div className="form-section">
              <h2 className="form-title">Client Info</h2>
              <div className="form-grid">
                <div className="form-group">
                  <div className="form-label">
                    <label>
                      Select Branch <span className="required">*</span>
                      <CiSquarePlus
                        className="add-icon"
                        onClick={() => setBranchModal(true)}
                        title="Add Branch"
                      />
                    </label>
                  </div>
                  <Field
                    name="branch_id"
                    component={CustomSelect}
                    options={branchData?.map((item) => ({
                      label: item.branch_name,
                      value: item.id,
                    }))}
                    // disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="branch_id"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="business_type"> Business Type</label>
                  <Field
                    name="business_type"
                    component={CustomSelect}
                    options={businessTypeData}
                    onChange={(event) => {
                      const selectedValue = event.value;
                      fetchDataTaxHead(selectedValue);
                    }}
                    disabled={id ? true : false}
                  />
                  <ErrorMessage
                    name="business_type"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="company_type"> Company Type</label>
                  <Field
                    name="company_type"
                    component={CustomSelect}
                    options={companyType}
                    onChange={(event) => {
                      const selectedValue = event.target.value;
                    }}
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="company_type"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="company_name">
                    Company Name
                    <span className="valid-msg">*</span>
                  </label>
                  <Field
                    id="company_name"
                    name="company_name"
                    className="form-control"
                    type="text"
                    placeholder="Please enter company name"
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="company_name"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="dba_name">DBA Name</label>
                  <Field
                    id="dba_name"
                    className="form-control"
                    name="dba_name"
                    type="text"
                    placeholder="Please enter DBA name "
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="dba_name"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="client_since"> Client Since</label>

                  <input
                    type="date"
                    id="client_since"
                    name="client_since"
                    className={`usa-input ${
                      errors.client_since && touched.client_since
                        ? "usa-input--error"
                        : ""
                    }`}
                    value={
                      values.client_since
                        ? new Date(values.client_since)
                            .toISOString()
                            .split("T")[0]
                        : ""
                    }
                    onChange={(e) => {
                      const selectedDate = e.target.value
                        ? new Date(e.target.value)
                        : "";
                      setFieldValue("client_since", selectedDate);
                    }}
                    disabled={forTaxHead ? true : false}
                    style={{ marginTop: "-1px" }}
                  />
                  <ErrorMessage
                    name="client_since"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="date_est"> Date Est./Inc.</label>
                  <input
                    type="date"
                    id="date_est"
                    name="date_est"
                    className={`usa-input ${
                      errors.date_est && touched.date_est
                        ? "usa-input--error"
                        : ""
                    }`}
                    value={
                      values.date_est
                        ? new Date(values.date_est).toISOString().split("T")[0]
                        : ""
                    }
                    onChange={(e) => {
                      const selectedDate = e.target.value
                        ? new Date(e.target.value)
                        : "";
                      setFieldValue("date_est", selectedDate);
                    }}
                    disabled={forTaxHead ? true : false}
                    style={{ marginTop: "-1px" }}
                  />
                  <ErrorMessage
                    name="date_est "
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="client_owner"> Client Owner</label>
                  <Field
                    id="client_owner"
                    className="form-control"
                    name="client_owner"
                    type="text"
                    placeholder="Please enter client owner"
                    disabled={forTaxHead ? true : false}
                  />

                  <ErrorMessage
                    name="client_owner"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="external_id"> External Id</label>
                  <Field
                    id="external_id"
                    className="form-control"
                    name="external_id"
                    type="number"
                    placeholder="Please enter external id"
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="external_id"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email"> Email</label>
                  <Field
                    id="email"
                    className="form-control"
                    name="email"
                    type="text"
                    placeholder="Please enter email"
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="s_and_u_number"> S&U Number</label>

                  <MaskedInputField
                    id="s_and_u_number"
                    name="s_and_u_number"
                    mask="111-111111"
                    placeholder="Please enter S&U number"
                    disabled={forTaxHead ? true : false}
                    className="form-control"
                  />
                  <ErrorMessage
                    name="s_and_u_number"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="ein_number">EIN Number</label>
                  <MaskedInputField
                    id="ein_number"
                    name="ein_number"
                    mask="11-1111111"
                    placeholder="Please enter EIN number"
                    disabled={forTaxHead}
                    className="form-control"
                  />
                  <ErrorMessage
                    name="ein_number"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="company_occupation_no">
                    {" "}
                    Company Occupancy No.
                  </label>
                  <Field
                    id="company_occupation_no"
                    className="form-control"
                    name="company_occupation_no"
                    type="text"
                    placeholder="Please enter company occupancy no."
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="company_occupation_no"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="hm_fee"> HM Fee.</label>
                  <Field
                    id="hm_fee"
                    className="form-control"
                    name="hm_fee"
                    type="text"
                    placeholder="Please enter HM Fee"
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="hm_fee"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="industry">Industry</label>
                  <Field
                    id="industry"
                    className="form-control"
                    name="industry"
                    type="text"
                    placeholder="Please enter industry"
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="industry"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="customer_name"> Customer Name</label>
                  <Field
                    id="customer_name"
                    className="form-control"
                    name="customer_name"
                    type="text"
                    placeholder="Please enter customer name"
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="customer_name"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="mobile_no"> Mobile Number</label>
                  <PhoneInput
                    name={"mobile_no"}
                    country="us"
                    inputStyle={{
                      width: "100%",
                    }}
                    inputProps={{
                      name: "mobile",
                      required: true,
                    }}
                    style={{
                      color: "red",
                    }}
                    value={values.mobile_no || ""}
                    onChange={(phone) => setFieldValue(`mobile_no`, phone)}
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="mobile_no"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="landline_no"> Landline No.</label>
                  <Field
                    id="landline_no"
                    className="form-control"
                    name="landline_no"
                    type="number"
                    placeholder="Please enter landline number"
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="landline_no"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <div className="form-label">
                    <label>
                      Zipcode <span className="required">*</span>{" "}
                      <CiSquarePlus
                        className="add-icon"
                        onClick={() => setCountyModal(true)}
                        title="Add Branch"
                      />
                    </label>
                  </div>
                  <Field
                    id="zip_code"
                    className="form-control"
                    name="zip_code"
                    type="text"
                    placeholder="Please enter Zipcode"
                    disabled={forTaxHead}
                    onChange={(event) => {
                      const selectedValue = event.target.value;
                      setFieldValue("zip_code", selectedValue);
                      if (selectedValue.length === 5) {
                        zipcodeData(
                          values.state_id,
                          selectedValue,
                          setFieldValue
                        );
                      }
                    }}
                    // disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="zip_code"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <div className="form-label">
                    <label>
                      State <span className="required">*</span>{" "}
                      <CiSquarePlus
                        className="add-icon"
                        onClick={() => setStateModal(true)}
                        title="Add Branch"
                      />
                    </label>
                  </div>
                  <Field
                    id="state_id"
                    className="form-control"
                    name="state_id"
                    type="text"
                    placeholder="Please enter State"
                    disabled={true}
                  />
                  <ErrorMessage
                    name="state_id"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="city">City</label>
                  <Field
                    id="city"
                    className="form-control"
                    name="city"
                    type="text"
                    placeholder="Please enter city"
                    disabled={true}
                  />
                  <ErrorMessage
                    name="city"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="county">County</label>
                  <Field
                    id="county"
                    className="form-control"
                    name="county"
                    type="text"
                    placeholder="Please enter county"
                    disabled={true}
                  />
                  <ErrorMessage
                    name="county"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="street_1"> Street 1</label>
                  <Field
                    id="street_1"
                    className="form-control"
                    name="street_1"
                    type="text"
                    placeholder="Please enter street 1"
                    disabled={forTaxHead ? true : false}
                    style={{
                      padding: "8px 12px",
                    }}
                  />
                  <ErrorMessage
                    name="street_1"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="street_2"> Street 2</label>
                  <Field
                    id="street_2"
                    className="form-control"
                    name="street_2"
                    type="text"
                    placeholder="Please enter street 2"
                    disabled={forTaxHead ? true : false}
                    style={{
                      padding: "8px 12px",
                    }}
                  />
                  <ErrorMessage
                    name="street_2"
                    component="div"
                    className="error-message"
                  />
                </div>
              </div>
              <h2 className="form-title">Bank Details</h2>
              <div className="modern-grid">
                <FieldArray name="bank_details">
                  {({ insert, remove, push }) => (
                    <>
                      {values.bank_details?.length > 0 &&
                        values?.bank_details.map((doc, index) => (
                          <div
                            key={index}
                            className="rounded-lg p-5 mb-6 shadow-md"
                          >
                            <div className="bank-account-card">
                              <div className="account-top">
                                <div className="account-title">
                                  Account #{index + 1}
                                </div>
                                <div className="account-btns">
                                  <button
                                    type="button"
                                    className="icon-btn add"
                                    onClick={() =>
                                      push({
                                        bank_account_no: "",
                                        routing_number: "",
                                        bank_micr_code: "",
                                        bank_name: "",
                                        account_holder_name: "",
                                        bank_branch: "",
                                        website: "",
                                        username: "",
                                        password: "",
                                        assigner: "",
                                        reviewer: "",
                                        is_primary: false,
                                      })
                                    }
                                  >
                                    <AiOutlinePlus size={18} />
                                    <span>Add</span>
                                  </button>

                                  {index > 0 && (
                                    <button
                                      type="button"
                                      className="icon-btn remove"
                                      onClick={() => remove(index)}
                                    >
                                      <AiOutlineDelete size={18} />
                                      <span>Remove</span>
                                    </button>
                                  )}
                                </div>
                              </div>

                              <div className="primary-toggle">
                                <Field
                                  type="checkbox"
                                  name={`bank_details.${index}.is_primary`}
                                  onClick={() => {
                                    const updatedDocs = values.bank_details.map(
                                      (item, idx) => ({
                                        ...item,
                                        is_primary: idx === index,
                                      })
                                    );
                                    setFieldValue("bank_details", updatedDocs);
                                  }}
                                  disabled={forTaxHead ? true : false}
                                />
                                <label
                                  htmlFor={`bank_details.${index}.is_primary`}
                                >
                                  Primary Account
                                </label>
                                {errors.bank_details &&
                                  errors.bank_details[index] &&
                                  errors.bank_details[index].is_primary &&
                                  touched.bank_details &&
                                  touched.bank_details[index] &&
                                  touched.bank_details[index].is_primary && (
                                    <div className="error-msg">
                                      {errors.bank_details[index].is_primary}
                                    </div>
                                  )}
                              </div>
                            </div>

                            {/* All Fields in One Row */}
                            <div className="form-grid">
                              <div className="form-group">
                                <label>
                                  Account Holder Name
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  id="account_holder_name"
                                  name={`bank_details.${index}.account_holder_name`}
                                  type="text"
                                  placeholder="Please enter account holder name"
                                  disabled={forTaxHead ? true : false}
                                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                />
                                {errors.bank_details &&
                                  errors.bank_details[index] &&
                                  errors.bank_details[index]
                                    .account_holder_name &&
                                  touched.bank_details &&
                                  touched.bank_details[index] &&
                                  touched.bank_details[index]
                                    .account_holder_name && (
                                    <div className="error-msg">
                                      {
                                        errors.bank_details[index]
                                          .account_holder_name
                                      }
                                    </div>
                                  )}
                              </div>

                              <div className="form-group">
                                <label>
                                  Bank Name{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  id="bank_name"
                                  name={`bank_details.${index}.bank_name`}
                                  type="text"
                                  placeholder="Please enter bank name"
                                  disabled={forTaxHead ? true : false}
                                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                />
                                {errors.bank_details &&
                                  errors.bank_details[index] &&
                                  errors.bank_details[index].bank_name &&
                                  touched.bank_details &&
                                  touched.bank_details[index] &&
                                  touched.bank_details[index].bank_name && (
                                    <div className="error-msg">
                                      {errors.bank_details[index].bank_name}
                                    </div>
                                  )}
                              </div>

                              <div className="form-group">
                                <label>
                                  Bank Branch{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  id="bank_branch"
                                  s
                                  name={`bank_details.${index}.bank_branch`}
                                  type="text"
                                  placeholder="Please enter bank branch"
                                  disabled={forTaxHead ? true : false}
                                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                />
                                {errors.bank_details &&
                                  errors.bank_details[index] &&
                                  errors.bank_details[index].bank_branch &&
                                  touched.bank_details &&
                                  touched.bank_details[index] &&
                                  touched.bank_details[index].bank_branch && (
                                    <div className="error-msg">
                                      {errors.bank_details[index].bank_branch}
                                    </div>
                                  )}
                              </div>

                              <div className="form-group">
                                <label>
                                  Account Type{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  id="account_type"
                                  name={`bank_details.${index}.account_type`}
                                  type="text"
                                  placeholder="Please enter account type"
                                  disabled={forTaxHead ? true : false}
                                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                />
                                {errors.bank_details &&
                                  errors.bank_details[index] &&
                                  errors.bank_details[index].account_type &&
                                  touched.bank_details &&
                                  touched.bank_details[index] &&
                                  touched.bank_details[index].account_type && (
                                    <div className="error-msg">
                                      {errors.bank_details[index].account_type}
                                    </div>
                                  )}
                              </div>

                              <div className="form-group">
                                <label>
                                  Bank Account No{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  id="bank_account_no"
                                  name={`bank_details.${index}.bank_account_no`}
                                  type="text"
                                  placeholder="Please enter bank account no"
                                  disabled={forTaxHead ? true : false}
                                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                />
                                {errors.bank_details &&
                                  errors.bank_details[index] &&
                                  errors.bank_details[index].bank_account_no &&
                                  touched.bank_details &&
                                  touched.bank_details[index] &&
                                  touched.bank_details[index]
                                    .bank_account_no && (
                                    <div className="error-msg">
                                      {
                                        errors.bank_details[index]
                                          .bank_account_no
                                      }
                                    </div>
                                  )}
                              </div>

                              <div className="form-group">
                                <label>
                                  Confirm Account No{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  id="bank_account_no_cnf"
                                  name={`bank_details.${index}.bank_account_no_cnf`}
                                  type="text"
                                  placeholder="Please enter confirm bank account no"
                                  disabled={forTaxHead ? true : false}
                                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                />
                                {errors.bank_details &&
                                  errors.bank_details[index] &&
                                  errors.bank_details[index]
                                    .bank_account_no_cnf &&
                                  touched.bank_details &&
                                  touched.bank_details[index] &&
                                  touched.bank_details[index]
                                    .bank_account_no_cnf && (
                                    <div className="error-msg">
                                      {
                                        errors.bank_details[index]
                                          .bank_account_no_cnf
                                      }
                                    </div>
                                  )}
                              </div>

                              <div className="form-group">
                                <label>
                                  Routing Number{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  id="routing_number"
                                  name={`bank_details.${index}.routing_number`}
                                  type="text"
                                  placeholder="Please routing number"
                                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                />
                                {errors.bank_details &&
                                  errors.bank_details[index] &&
                                  errors.bank_details[index].routing_number &&
                                  touched.bank_details &&
                                  touched.bank_details[index] &&
                                  touched.bank_details[index]
                                    .routing_number && (
                                    <div className="error-msg">
                                      {
                                        errors.bank_details[index]
                                          .routing_number
                                      }
                                    </div>
                                  )}
                              </div>

                              <div className="form-group">
                                <label>
                                  Username
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  id="username"
                                  name={`bank_details.${index}.username`}
                                  type="text"
                                  disabled={forTaxHead ? true : false}
                                  placeholder="Please enter username"
                                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                />
                                {errors.bank_details &&
                                  errors.bank_details[index] &&
                                  errors.bank_details[index].username &&
                                  touched.bank_details &&
                                  touched.bank_details[index] &&
                                  touched.bank_details[index].username && (
                                    <div className="error-msg">
                                      {errors.bank_details[index].username}
                                    </div>
                                  )}
                              </div>
                              <div className="form-group">
                                <label>
                                  Password
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  id="password"
                                  name={`bank_details.${index}.password`}
                                  type="text"
                                  placeholder="Please enter password"
                                  disabled={forTaxHead ? true : false}
                                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                />
                                {errors.bank_details &&
                                  errors.bank_details[index] &&
                                  errors.bank_details[index].password &&
                                  touched.bank_details &&
                                  touched.bank_details[index] &&
                                  touched.bank_details[index].password && (
                                    <div className="error-msg">
                                      {errors.bank_details[index].password}
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        ))}
                    </>
                  )}
                </FieldArray>
              </div>

              <h2 className="form-title">Tax Info (Vendor Composition)</h2>
              <div className="tax-form-container">
                {/* Business Type Header */}
                {groupedData && (
                  <>
                    <div className="form-header">
                      <h2 className="business-type-header">
                        {values.business_type}
                      </h2>
                    </div>
                    <div className="tax-card">
                      <table className="tax-group-table">
                        <thead>
                          <tr>
                            <th>Head Type</th>
                            <th>Tax Head Names</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.entries(groupedData).map(([type, names]) => (
                            <tr key={type}>
                              <td className="text-bold">{type}</td>
                              <td>
                                {names.map((name, i) => (
                                  <span key={i} className="tax-pill">
                                    {name}
                                  </span>
                                ))}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}

                {/* Tax Information Cards */}
                <FieldArray name="tax_info">
                  {({ insert, remove, push }) => (
                    <>
                      {values.tax_info?.length > 0 &&
                        values.tax_info.map((doc, index) => (
                          <div className="tax-card" key={`tax-${index}`}>
                            <div className="tax-info-header">
                              <div className="toggle-group">
                                <label className="toggle-checkbox">
                                  <Field
                                    type="checkbox"
                                    name={`tax_info.${index}.is_off_on_road`}
                                    onClick={() => {
                                      const updatedDocs = values.tax_info.map(
                                        (item, idx) => ({
                                          ...item,
                                          is_off_on_road: idx === index,
                                        })
                                      );
                                      setFieldValue(
                                        "is_off_on_road",
                                        updatedDocs
                                      );
                                    }}
                                  />
                                  <span className="toggle-slider"></span>
                                </label>
                                <span className="ms-2">Off/ON Road</span>
                              </div>

                              <div className="toggle-group">
                                <label className="toggle-checkbox">
                                  <Field
                                    type="checkbox"
                                    name={`tax_info.${index}.is_prepaid`}
                                    onClick={() => {
                                      const updatedDocs = values.tax_info.map(
                                        (item, idx) => ({
                                          ...item,
                                          is_prepaid: idx === index,
                                        })
                                      );
                                      setFieldValue("is_prepaid", updatedDocs);
                                    }}
                                  />
                                  <span className="toggle-slider"></span>
                                </label>
                                <span className="ms-2">Prepaid/Postpaid</span>
                              </div>

                              <div>
                                <button
                                  className="btn btn-primary btn-icon"
                                  type="button"
                                  onClick={() =>
                                    push({
                                      state: "",
                                      county: "",
                                      total_ga_tax: "",
                                      state_tax: "",
                                      county_tax: "",
                                      occup_tax: "",
                                      occup_credit: "",
                                      per_room_tax: "",
                                      zip_code: "",
                                      is_off_on_road: true,
                                      is_prepaid: true,
                                      food_sales: "",
                                      non_food: "",
                                      cbd_sales: "",
                                      local_tax: "",
                                      state_tax_status: true,
                                      county_tax_status: true,
                                      total_ga_tax_status: true,
                                      food_sales_status: true,
                                      non_food_status: true,
                                      cbd_sales_status: true,
                                      local_tax_status: true,
                                      vendor_comp_above_status: true,
                                      vendor_comp_below_status: true,
                                      on_road_fuel_status: true,
                                      off_road_fuel_status: true,
                                      occup_tax_status: true,
                                      occup_credit_status: true,
                                      per_room_tax_status: true,
                                    })
                                  }
                                >
                                  <span>+</span>
                                </button>

                                <button
                                  className="btn btn-secondary btn-icon"
                                  type="button"
                                  onClick={() => remove(index)}
                                  disabled={index === 0}
                                >
                                  <span>×</span>
                                </button>
                              </div>
                            </div>

                            <div className="tax-info-body">
                              {/* Location Information */}
                              <div className="form-row">
                                <div className="form-col form-col-3">
                                  <label
                                    className="form-label"
                                    htmlFor={`tax_info.${index}.zip_code`}
                                  >
                                    Zipcode{" "}
                                    <span className="required-indicator">
                                      *
                                    </span>
                                  </label>
                                  <Field
                                    id={`tax_info.${index}.zip_code`}
                                    className="form-control"
                                    name={`tax_info.${index}.zip_code`}
                                    type="number"
                                    placeholder="Enter zipcode"
                                    onChange={(event) => {
                                      const selectedValue = event.target.value;
                                      setFieldValue(
                                        `tax_info.${index}.zip_code`,
                                        selectedValue
                                      );
                                      if (selectedValue.length === 5) {
                                        zipcodeDataVenderConp(
                                          values?.state_id,
                                          selectedValue,
                                          setFieldValue,
                                          index
                                        );
                                      }
                                    }}
                                    disabled={index === 0}
                                  />
                                </div>

                                <div className="form-col form-col-3">
                                  <label
                                    className="form-label"
                                    htmlFor={`tax_info.${index}.state`}
                                  >
                                    State{" "}
                                    <span className="required-indicator">
                                      *
                                    </span>
                                  </label>
                                  <Field
                                    id={`tax_info.${index}.state`}
                                    className="form-control"
                                    name={`tax_info.${index}.state`}
                                    type="text"
                                    placeholder="State"
                                    disabled={true}
                                  />
                                </div>

                                <div className="form-col form-col-3">
                                  <label
                                    className="form-label"
                                    htmlFor={`tax_info.${index}.city`}
                                  >
                                    City{" "}
                                    <span className="required-indicator">
                                      *
                                    </span>
                                  </label>
                                  <Field
                                    id={`tax_info.${index}.city`}
                                    className="form-control"
                                    name={`tax_info.${index}.city`}
                                    type="text"
                                    placeholder="City"
                                    disabled={true}
                                  />
                                  {errors.tax_info &&
                                    errors.tax_info[index] &&
                                    errors.tax_info[index].city &&
                                    touched.tax_info &&
                                    touched.tax_info[index] &&
                                    touched.tax_info[index].city && (
                                      <span className="error-message">
                                        {errors.tax_info[index].city}
                                      </span>
                                    )}
                                </div>

                                <div className="form-col form-col-3">
                                  <label
                                    className="form-label"
                                    htmlFor={`tax_info.${index}.county`}
                                  >
                                    County{" "}
                                    <span className="required-indicator">
                                      *
                                    </span>
                                  </label>
                                  <Field
                                    id={`tax_info.${index}.county`}
                                    className="form-control"
                                    name={`tax_info.${index}.county`}
                                    type="text"
                                    placeholder="County"
                                    disabled={true}
                                  />
                                  {errors.tax_info &&
                                    errors.tax_info[index] &&
                                    errors.tax_info[index].county &&
                                    touched.tax_info &&
                                    touched.tax_info[index] &&
                                    touched.tax_info[index].county && (
                                      <span className="error-message">
                                        {errors.tax_info[index].county}
                                      </span>
                                    )}
                                </div>
                              </div>

                              {/* Primary Tax Rates */}
                              <h3 className="tax-category">
                                Primary Tax Rates
                              </h3>
                              <div className="form-row">
                                <div className="form-col form-col-4">
                                  <div className="tax-item">
                                    <h4 className="tax-item-value">
                                      State Tax{" "}
                                      {values.tax_info[index].state_tax || 0}%
                                    </h4>
                                    <label className="toggle-checkbox">
                                      <Field
                                        type="checkbox"
                                        name={`tax_info.${index}.state_tax_status`}
                                        checked={
                                          values.tax_info[index]
                                            ?.state_tax_status || false
                                        }
                                      />
                                      <span className="toggle-slider"></span>
                                    </label>
                                  </div>
                                </div>

                                <div className="form-col form-col-4">
                                  <div className="tax-item">
                                    <h4 className="tax-item-value">
                                      County Tax{" "}
                                      {values.tax_info[index].county_tax || 0}%
                                    </h4>
                                    <label className="toggle-checkbox">
                                      <Field
                                        type="checkbox"
                                        name={`tax_info.${index}.county_tax_status`}
                                        checked={
                                          values.tax_info[index]
                                            ?.county_tax_status || false
                                        }
                                      />
                                      <span className="toggle-slider"></span>
                                    </label>
                                  </div>
                                </div>

                                <div className="form-col form-col-4">
                                  <div className="tax-item">
                                    <h4 className="tax-item-value">
                                      Total Tax{" "}
                                      {values.tax_info[index].total_ga_tax || 0}
                                      %
                                    </h4>
                                    <label className="toggle-checkbox">
                                      <Field
                                        type="checkbox"
                                        name={`tax_info.${index}.total_ga_tax_status`}
                                        checked={
                                          values.tax_info[index]
                                            ?.total_ga_tax_status || false
                                        }
                                      />
                                      <span className="toggle-slider"></span>
                                    </label>
                                  </div>
                                </div>
                              </div>

                              {/* Sales Tax Rates */}
                              <h3 className="tax-category">Sales Tax Rates</h3>
                              <div className="form-row">
                                <div className="form-col form-col-3">
                                  <div className="tax-item">
                                    <h4 className="tax-item-value">
                                      Food Sales{" "}
                                      {values.tax_info[index].food_sales || 0}%
                                    </h4>
                                    <label className="toggle-checkbox">
                                      <Field
                                        type="checkbox"
                                        name={`tax_info.${index}.food_sales_status`}
                                        checked={
                                          values.tax_info[index]
                                            ?.food_sales_status || false
                                        }
                                      />
                                      <span className="toggle-slider"></span>
                                    </label>
                                  </div>
                                </div>

                                <div className="form-col form-col-3">
                                  <div className="tax-item">
                                    <h4 className="tax-item-value">
                                      Non-Food{" "}
                                      {values.tax_info[index].non_food || 0}%
                                    </h4>
                                    <label className="toggle-checkbox">
                                      <Field
                                        type="checkbox"
                                        name={`tax_info.${index}.non_food_status`}
                                        checked={
                                          values.tax_info[index]
                                            ?.non_food_status || false
                                        }
                                      />
                                      <span className="toggle-slider"></span>
                                    </label>
                                  </div>
                                </div>

                                <div className="form-col form-col-3">
                                  <div className="tax-item">
                                    <h4 className="tax-item-value">
                                      CBD Sales{" "}
                                      {values.tax_info[index].cbd_sales || 0}%
                                    </h4>
                                    <label className="toggle-checkbox">
                                      <Field
                                        type="checkbox"
                                        name={`tax_info.${index}.cbd_sales_status`}
                                        checked={
                                          values.tax_info[index]
                                            ?.cbd_sales_status || false
                                        }
                                      />
                                      <span className="toggle-slider"></span>
                                    </label>
                                  </div>
                                </div>

                                <div className="form-col form-col-3">
                                  <div className="tax-item">
                                    <h4 className="tax-item-value">
                                      Local Sales{" "}
                                      {values.tax_info[index].local_tax || 0}%
                                    </h4>
                                    <label className="toggle-checkbox">
                                      <Field
                                        type="checkbox"
                                        name={`tax_info.${index}.local_tax_status`}
                                        checked={
                                          values.tax_info[index]
                                            ?.local_tax_status || false
                                        }
                                      />
                                      <span className="toggle-slider"></span>
                                    </label>
                                  </div>
                                </div>
                              </div>

                              {/* Vendor and Fuel Tax Rates */}
                              <h3 className="tax-category">
                                Vendor & Fuel Tax Rates
                              </h3>
                              <div className="form-row">
                                <div className="form-col form-col-3">
                                  <div className="tax-item">
                                    <h4 className="tax-item-value">
                                      Vendor Comp (Below $
                                      {values.tax_info[index]
                                        .vendor_comp_above_rate || 3000}
                                      ){" "}
                                      {values.tax_info[index]
                                        .vendor_comp_above || 0}
                                      %
                                    </h4>
                                    <label className="toggle-checkbox">
                                      <Field
                                        type="checkbox"
                                        name={`tax_info.${index}.vendor_comp_above_status`}
                                        checked={
                                          values.tax_info[index]
                                            ?.vendor_comp_above_status || false
                                        }
                                      />
                                      <span className="toggle-slider"></span>
                                    </label>
                                  </div>
                                </div>

                                <div className="form-col form-col-3">
                                  <div className="tax-item">
                                    <h4 className="tax-item-value">
                                      Vendor Comp (Above $
                                      {values.tax_info[index]
                                        .vendor_comp_above_rate || 3000}
                                      ){" "}
                                      {values.tax_info[index]
                                        .vendor_comp_below || 0}
                                      %
                                    </h4>
                                    <label className="toggle-checkbox">
                                      <Field
                                        type="checkbox"
                                        name={`tax_info.${index}.vendor_comp_below_status`}
                                        checked={
                                          values.tax_info[index]
                                            ?.vendor_comp_below_status || false
                                        }
                                      />
                                      <span className="toggle-slider"></span>
                                    </label>
                                  </div>
                                </div>

                                <div className="form-col form-col-3">
                                  <div className="tax-item">
                                    <h4 className="tax-item-value">
                                      On Road Fuel{" "}
                                      {values.tax_info[index].on_road_fuel || 0}
                                      %
                                    </h4>
                                    <label className="toggle-checkbox">
                                      <Field
                                        type="checkbox"
                                        name={`tax_info.${index}.on_road_fuel_status`}
                                        checked={
                                          values.tax_info[index]
                                            ?.on_road_fuel_status || false
                                        }
                                      />
                                      <span className="toggle-slider"></span>
                                    </label>
                                  </div>
                                </div>

                                <div className="form-col form-col-3">
                                  <div className="tax-item">
                                    <h4 className="tax-item-value">
                                      Off Road Fuel{" "}
                                      {values.tax_info[index].off_road_fuel ||
                                        0}
                                      %
                                    </h4>
                                    <label className="toggle-checkbox">
                                      <Field
                                        type="checkbox"
                                        name={`tax_info.${index}.off_road_fuel_status`}
                                        checked={
                                          values.tax_info[index]
                                            ?.off_road_fuel_status || false
                                        }
                                      />
                                      <span className="toggle-slider"></span>
                                    </label>
                                  </div>
                                </div>
                              </div>

                              {/* Hotel-Motel Specific Fields */}
                              {values.business_type === "Hotel - Motel" && (
                                <div className="hotel-motel-section">
                                  <h3 className="tax-category">
                                    Hotel-Motel Specific Taxes
                                  </h3>
                                  <div className="form-row">
                                    <div className="form-col form-col-4">
                                      <div className="tax-item">
                                        <h4 className="tax-item-value">
                                          Occup Tax{" "}
                                          {values.tax_info[index].occup_tax ||
                                            0}
                                          %
                                        </h4>
                                        <label className="toggle-checkbox">
                                          <Field
                                            type="checkbox"
                                            name={`tax_info.${index}.occup_tax_status`}
                                            checked={
                                              values.tax_info[index]
                                                ?.occup_tax_status || false
                                            }
                                          />
                                          <span className="toggle-slider"></span>
                                        </label>
                                      </div>
                                    </div>

                                    <div className="form-col form-col-4">
                                      <div className="tax-item">
                                        <h4 className="tax-item-value">
                                          Occup Credit{" "}
                                          {values.tax_info[index]
                                            .occup_credit || 0}
                                          %
                                        </h4>
                                        <label className="toggle-checkbox">
                                          <Field
                                            type="checkbox"
                                            name={`tax_info.${index}.occup_credit_status`}
                                            checked={
                                              values.tax_info[index]
                                                ?.occup_credit_status || false
                                            }
                                          />
                                          <span className="toggle-slider"></span>
                                        </label>
                                      </div>
                                    </div>

                                    <div className="form-col form-col-4">
                                      <div className="tax-item">
                                        <h4 className="tax-item-value">
                                          Per Room Tax{" "}
                                          {values.tax_info[index]
                                            .per_room_tax || 0}
                                          %
                                        </h4>
                                        <label className="toggle-checkbox">
                                          <Field
                                            type="checkbox"
                                            name={`tax_info.${index}.per_room_tax_status`}
                                            checked={
                                              values.tax_info[index]
                                                ?.per_room_tax_status || false
                                            }
                                          />
                                          <span className="toggle-slider"></span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                    </>
                  )}
                </FieldArray>
              </div>
              <h2 className="form-title">Assignee</h2>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="email_operator_id">
                    {" "}
                    Select Email Operator
                  </label>
                  <Field
                    name="email_operator_id"
                    component={CustomSelect}
                    options={emailOperatorData}
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="email_operator_id"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="data_entry_operator_id">
                    {" "}
                    Select Data Entry Operator
                  </label>
                  <Field
                    name="data_entry_operator_id"
                    component={CustomSelect}
                    options={dataEntryOperatorData}
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="data_entry_operator_id"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="reviewer_id"> Select Reviewer</label>
                  <Field
                    name="reviewer_id"
                    component={CustomSelect}
                    options={reviewerData}
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="reviewer_id"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="team_lead_id"> Select Team Lead</label>
                  <Field
                    name="team_lead_id"
                    component={CustomSelect}
                    options={teamLeadData}
                    disabled={forTaxHead ? true : false}
                  />
                  <ErrorMessage
                    name="team_lead_id"
                    component="div"
                    className="error-message"
                  />
                </div>
              </div>
              <div id="target-section">
                {forTaxHead && (
                  <div className="margin-top-3 padding-bottom-2 border-bottom-1px border-base-light">
                    <div className="display-flex flex-align-center margin-bottom-2">
                      <svg
                        className="usa-icon text-primary margin-right-1"
                        xmlns="http://www.w3.org/2000/svg"
                        height="12"
                        width="12"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <circle cx="12" cy="12" r="4" />
                      </svg>
                      <h3 className="font-sans-md margin-0">Tax Head</h3>
                    </div>

                    <div className="form-grid">
                      <div className="form-group">
                        <label className="usa-label" htmlFor="tax_head">
                          Tax Head <span className="text-red">*</span>
                        </label>
                        <Field
                          name="tax_head"
                          component={CustomSelect}
                          options={taxHeadData}
                          isMulti={true}
                          className="usa-select modern-select"
                          disabled={true}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="form-footer">
              <button type="submit" className="btn btn-submit">
                {id ? "Update" : "Submit"}
              </button>
            </div>
          </Form>
        )}
      </Formik>

      {branchModal && (
        <CommonModal
          open={branchModal}
          onClose={handleClose}
          title={"Add Branch"}
          size="large"
        >
          <BranchForm onClose={handleClose} />
        </CommonModal>
      )}
      {stateModal && (
        <CommonModal
          open={stateModal}
          onClose={handleClose}
          title={"Add State"}
          size="large"
        >
          <StateForms onClose={handleClose} />
        </CommonModal>
      )}
      {cityModal && (
        <CommonModal
          open={cityModal}
          onClose={handleClose}
          title={"Add City"}
          size="large"
        >
          {/* <CityForm onClose={handleClose} /> */}
        </CommonModal>
      )}
      {countyModal && (
        <CommonModal
          open={countyModal}
          onClose={handleClose}
          title={"Add County"}
          size="large"
        >
          <CountyForm onClose={handleClose} />
        </CommonModal>
      )}
    </div>
  );
}
